var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownloadIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.727295 16.5H16V14.6176H0.727295V16.5ZM16 6.14706H11.6364V0.5H5.09093V6.14706H0.727295L8.36366 12.7353L16 6.14706Z",
    fill: "#979797"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DownloadIcon.0b4952ff.svg";
export { ForwardRef as ReactComponent };